import React from 'react';
import { SxProps } from '@mui/system';
import { useZonesManagement } from '../../hooks/useZonesManagement';
import { Button } from 'framework/ui/mui-builder';
import { DropdownMenu } from 'framework/ui/menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { capitalize } from 'lodash';
import { useFieldHelper } from 'framework/ui/field';
import { ZONE_LABELS } from 'domain/staffing/dashboard/constants';

interface StaffingDashboardZoneChangeButtonProps {
  buttonSx?: SxProps;
  availableOnlyForZoneView?: boolean;
}

const StaffingDashboardZoneChangeButton: React.FC<StaffingDashboardZoneChangeButtonProps> = ({
  availableOnlyForZoneView,
  buttonSx,
}) => {
  const { zoneOptions, zones } = useZonesManagement();
  const { getValue } = useFieldHelper({ source: 'staffingRisk.priority' });
  const currentZone = getValue() as string;

  const filteredOptions = zoneOptions.filter(option => option.key.replace('zone-', '') !== currentZone);
  const currentLabel = capitalize(String(zones[currentZone as keyof typeof ZONE_LABELS] || currentZone).toLowerCase());

  if (availableOnlyForZoneView) {
    return (
      <span
        style={{
          padding: '4px 16px',
          minWidth: '104px',
          fontSize: 12,
          fontWeight: 200,
          color: 'inherit',
          ...(buttonSx as object),
        }}
      >
        {currentLabel}
      </span>
    );
  }

  return (
    <DropdownMenu
      popupId="change-zone-menu"
      sxPaper={{ minWidth: '104px' }}
      disablePortal={false}
      iconButton={
        <Button
          size="small"
          variant="text"
          sx={{
            padding: '4px 16px',
            minWidth: '104px',
            justifyContent: 'space-between',
            fontSize: 12,
            fontWeight: 200,
            ...buttonSx,
          }}
        >
          {currentLabel}
          <KeyboardArrowDownIcon sx={{ fontSize: '18px' }} />
        </Button>
      }
    >
      {filteredOptions.map(option => (
        <MenuItem key={option.key} onClick={option.onClick}>
          {option.label}
        </MenuItem>
      ))}
    </DropdownMenu>
  );
};

export default StaffingDashboardZoneChangeButton;
